<template>
  <div class="application" >

    <div class="appl" 
        :class="[screenHeightNoChange ? 'appl2' : '']">

        <div class="header">
          根据监管要求，股票投顾类产品必须填写投资者基本信息表。本信息表将占用您两分钟的时间，敬请支持理解。
        </div>


        <div class="form_box2410">
          <van-form @submit="onSubmit" ref="ruleForm" 
          @failed="onFailed"
          >

          <div class="border"></div>

            <van-field
              :required="true"
              v-model="ruleForm.name"
              name="姓名"
              label="姓名"
              placeholder="姓名和身份证必须一致"
              :rules="rules.name"
            />

            <!-- disabled -->
            <van-field name="radio" label="性别" :rules="rules.sex" :required="true" >
              <template #input>
                <van-radio-group  v-model="ruleForm.sex" direction="horizontal">
                  <van-radio name="男">男</van-radio>
                  <van-radio name="女">女</van-radio>
                </van-radio-group>
              </template>
            </van-field>

            <!--  -->
            <van-field
              readonly
              :required="true"
              name="datetimePicker"
              :value="ruleForm.birth"
              :rules="rules.birth"
              label="出生日期"
              placeholder="请选择日期"
              @click="showPicker_date = true"
            />
            <van-popup v-model="showPicker_date" position="bottom">
              <van-datetime-picker
                item-height="88px"
                type="date"
                @confirm="onConfirm_date"
                @cancel="showPicker_date = false"
                v-model="currentDate"
                :min-date="minDate"
                :max-date="maxDate"
              />
            </van-popup>


            <!--  -->
            <van-field
              readonly
              name="picker"
              :value="ruleForm.country"
              :required="true"
              :rules="rules.country"
              label="国籍"
              placeholder="请选择国籍"
              @click="showPicker_country = true"
            />
            <van-popup v-model="showPicker_country" position="bottom">
              <van-picker
                show-toolbar
                item-height="88px"
                :columns="columns_country"
                @confirm="onConfirm_country"
                @cancel="showPicker_country = false"
              />
            </van-popup>

            <div class="border"></div>


            <van-field
              readonly
              clickable
              name="picker"
              :value="ruleForm.job"
              :required="true"
              :rules="rules.job"
              label="职业"
              placeholder="请选择职业"
              @click="showPicker_job = true"
            />
            <van-popup v-model="showPicker_job" position="bottom">
              <van-picker
                item-height="88px"
                show-toolbar
                :columns="options_job"
                @confirm="onConfirm_job"
                @cancel="showPicker_job = false"
              />
            </van-popup>

            <van-field
              v-model="ruleForm.workplace"
              name="工作单位"
              label="工作单位"
              placeholder="请输入工作单位（选填）"
            />

            <van-field
              v-model="ruleForm.office"
              name="职务"
              label="职务"
              placeholder="请输入职务（选填）"
            />

            <van-field
              readonly
              clickable
              name="picker"
              :value="ruleForm.degree"
              label="学历"
              placeholder="请选择学历（选填）"
              @click="showPicker_degree = true"
            />
            <van-popup v-model="showPicker_degree" position="bottom">
              <van-picker
                item-height="88px"
                show-toolbar
                :columns="options_degree"
                @confirm="onConfirm_degree"
                @cancel="showPicker_degree = false"
              />
            </van-popup>

            <div class="border"></div>


            <div class="integrity_box">

            

              <van-field name="radio" label="诚信记录" :rules="rules.integrity" :required="true">
                <template #input>
                  <van-radio-group v-model="ruleForm.integrity" direction="horizontal">
                    <van-radio name="0">无</van-radio>
                    <van-radio name="1">有（请注明）</van-radio>
                  </van-radio-group>
                </template>
              </van-field>

              <van-field name="checkboxGroup" label="诚信记录" :label-class="'other2'">
                <template #input>
                  <van-checkbox-group v-model="integrity_record" checked-color="#FE484A" direction="horizontal">
                    <van-checkbox name="中国人民银行征信中心" shape="square">中国人民银行征信中心</van-checkbox>
                    <van-checkbox name="最高人民法院失信被执行人名单" shape="square">最高人民法院失信被执行人名单</van-checkbox>
                    <van-checkbox name="工商行政管理机构" shape="square">工商行政管理机构</van-checkbox>
                    <van-checkbox name="税务管理机构" shape="square">税务管理机构</van-checkbox>
                    <van-checkbox name="监管机构、自律组织" shape="square">监管机构、自律组织</van-checkbox>
                    <van-checkbox name="投资者在证券经营机构的失信记录" shape="square">投资者在证券经营机构的失信记录</van-checkbox>
                    <van-checkbox name="其他" shape="square">其他</van-checkbox>
                  </van-checkbox-group>
                </template>
              </van-field>

              <van-field
                :label-class="'other2'"
                v-model="ruleForm.other"
                name="其他"
                label="其他"
                placeholder="请手动输入"
              />

            </div>


            <div class="border"></div>

            <van-field
              :required="true"
              v-model="ruleForm.card"
              type="number"
              name="身份证号"
              label="身份证号"
              placeholder="请输入身份证号"
              :rules="rules.card"
            />


            <van-field
              readonly
              clickable
              name="datetimePicker"
              :label-class="'other'"
              :value="ruleForm.expiration"
              label="身份证件有效期限"
              placeholder="请选择日期（选填）"
              @click="showPicker_expiration = true"
            />
            <van-popup v-model="showPicker_expiration" position="bottom">
              <van-datetime-picker
                type="date"
                item-height="88px"
                @confirm="onConfirm_expiration"
                @cancel="showPicker_expiration = false"
                :min-date="minDate2"
                :max-date="maxDate"
              />
            </van-popup>


            <van-field
              :required="true"
              v-model="ruleForm.phone"
              type="number"
              name="手机号"
              label="手机号"
              placeholder="请输入手机号"
              :rules="rules.phone"
            />


            <!-- @focus="scrollFn(true)"
            @blur="scrollFn(false)" -->
            <van-field
              v-model="ruleForm.address"
              rows="2"
              autosize
              label="联系地址"
              type="textarea"
              placeholder="请输入地址（选填）"

            />

            <div class="border"></div>

            <div class="sb_p" @click="agree = !agree;">
              <svg v-show="!agree" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                <rect x="2.5" y="2.5" width="17" height="17" rx="3.5" fill="white" stroke="#DCDCDC"/>
              </svg>
              <svg v-show="agree" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                <rect x="2.5" y="2.5" width="17" height="17" rx="3.5" stroke="#DCDCDC"/>
                <path d="M6.32275 11.2668L9.02709 13.9711C9.41761 14.3616 10.0508 14.3616 10.4413 13.9711L15.8838 8.52856" stroke="#FF443D" stroke-width="1.25" stroke-linecap="round"/>
              </svg>
              <span>本人保证资金来源的合法性和所提供资料的真实性、准确性、完整性，并对其承担责任。</span>
               
            </div>

            <div class="btn">
              <van-button color="#FF443D" square block type="info" native-type="submit">提交</van-button>
            </div>

          </van-form>
            
        </div>
    </div>

  </div>  

</template>

<script>
import { Toast } from 'vant';
import circleApi from "@/api/circle";

export default {
    data() {
      return {

        //表单数据
        ruleForm: {
          name: '',//姓名
          sex: '',//性别
          birth:null,//出生日期
          country:'',//国籍
          job:'',//职业
          workplace:'',//工作单位
          office:'',//职务
          degree:'',//学历

          integrity:'',//诚信记录
          other:'',
          card:'',//身份证件  接口返回，不支持修改
          expiration:null,//身份证件有效期限
          phone: '',//手机号  支持修改
          
          address : '',//联系地址
          
        },

        integrity_record:[],//诚信记录选择

        //校验
        rules: {
          name: [
            { required: true, message: '请输入姓名', 
              },
            {
              pattern: /^[\u4E00-\u9FA5]{2,4}$/,
              message: '请输入真实姓名',
            }
          ],
          card: [
            { required: true, message: '请输入身份证号', },
            {
              pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
              message: '身份证号格式有误',
            }
          ],
          phone: [
            { required: true, message: '请输入手机号',  }
          ],
          sex: [
            { required: true, message: '请选择性别', }
          ],
          integrity: [
            { required: true, message: '请选择诚信记录', }
          ],
          birth: [
            { required: true, message: '请选择出生日期', }
          ],
          country: [
            { required: true, message: '请选择国籍', }
          ],
          job: [
            { required: true, message: '请选择职业', }
          ],
        },

        agree:true,
      

        columns_country: [],
        options_country: [
          {value:'China',label:'中国'},
          {value:'Angola',label:'安哥拉'},
          {value:'Afghanistan',label:'阿富汗'},
          {value:'Albania',label:'阿尔巴尼亚'},
          {value:'Algeria',label:'阿尔及利亚'},
          {value:'Andorra',label:'安道尔共和国'},
          {value:'Anguilla',label:'安圭拉岛'},
          {value:'Antigua and Barbuda',label:'安提瓜和巴布达'},
          {value:'Argentina',label:'阿根廷'},
          {value:'Armenia',label:'亚美尼亚'},
          {value:'Ascension',label:'阿森松'},
          {value:'Australia',label:'澳大利亚'},
          {value:'Austria',label:'奥地利'},
          {value:'Azerbaijan',label:'阿塞拜疆'},
          {value:'Bahamas',label:'巴哈马'},
          {value:'Bahrain',label:'巴林'},
          {value:'Bangladesh',label:'孟加拉国'},
          {value:'Barbados',label:'巴巴多斯'},
          {value:'Belarus',label:'白俄罗斯'},
          {value:'Belgium',label:'比利时'},
          {value:'Belize',label:'伯利兹'},
          {value:'Benin',label:'贝宁'},
          {value:'Bermuda Is',label:'百慕大群岛'},
          {value:'Bolivia',label:'玻利维亚'},
          {value:'Botswana',label:'博茨瓦纳'},
          {value:'Brazil',label:'巴西'},
          {value:'Brunei',label:'文莱'},
          {value:'Bulgaria',label:'保加利亚'},
          {value:'Burkina Faso',label:'布基纳法索'},
          {value:'Burma',label:'缅甸'},
          {value:'Burundi',label:'布隆迪'},
          {value:'Cameroon',label:'喀麦隆'},
          {value:'Canada',label:'加拿大'},
          {value:'Cayman Is',label:'开曼群岛'},
          {value:'Central African Republic',label:'中非共和国'},
          {value:'Chad',label:'乍得'},
          {value:'Chile',label:'智利'},
          {value:'Colombia',label:'哥伦比亚'},
          {value:'Congo',label:'刚果'},
          {value:'Cook Is',label:'库克群岛'},
          {value:'Costa Rica',label:'哥斯达黎加'},
          {value:'Cuba',label:'古巴'},
          {value:'Cyprus',label:'塞浦路斯'},
          {value:'Czech Republic',label:'捷克'},
          {value:'Denmark',label:'丹麦'},
          {value:'Djibouti',label:'吉布提'},
          {value:'Dominica Rep',label:'多米尼加共和国'},
          {value:'Ecuador',label:'厄瓜多尔'},
          {value:'Egypt',label:'埃及'},
          {value:'EI Salvador',label:'萨尔瓦多'},
          {value:'Estonia',label:'爱沙尼亚'},
          {value:'Ethiopia',label:'埃塞俄比亚'},
          {value:'Fiji',label:'斐济'},
          {value:'Finland',label:'芬兰'},
          {value:'France',label:'法国'},
          {value:'French Guiana',label:'法属圭亚那'},
          {value:'French Polynesia',label:'法属玻利尼西亚'},
          {value:'Gabon',label:'加蓬'},
          {value:'Gambia',label:'冈比亚'},
          {value:'Georgia',label:'格鲁吉亚'},
          {value:'Germany',label:'德国'},
          {value:'Ghana',label:'加纳'},
          {value:'Gibraltar',label:'直布罗陀'},
          {value:'Greece',label:'希腊'},
          {value:'Grenada',label:'格林纳达'},
          {value:'Guam',label:'关岛'},
          {value:'Guatemala',label:'危地马拉'},
          {value:'Guinea',label:'几内亚'},
          {value:'Guyana',label:'圭亚那'},
          {value:'Haiti',label:'海地'},
          {value:'Honduras',label:'洪都拉斯'},
          {value:'Hungary',label:'匈牙利'},
          {value:'Iceland',label:'冰岛'},
          {value:'India',label:'印度'},
          {value:'Indonesia',label:'印度尼西亚'},
          {value:'Iran',label:'伊朗'},
          {value:'Iraq',label:'伊拉克'},
          {value:'Ireland',label:'爱尔兰'},
          {value:'Israel',label:'以色列'},
          {value:'Italy',label:'意大利'},
          {value:'Ivory Coast',label:'科特迪瓦'},
          {value:'Jamaica',label:'牙买加'},
          {value:'Japan',label:'日本'},
          {value:'Jordan',label:'约旦'},
          {value:'Kampuchea (Cambodia )',label:'柬埔寨'},
          {value:'Kazakstan',label:'哈萨克斯坦'},
          {value:'Kenya',label:'肯尼亚'},
          {value:'Korea',label:'韩国'},
          {value:'Kuwait',label:'科威特'},
          {value:'Kyrgyzstan',label:'吉尔吉斯坦'},
          {value:'Laos',label:'老挝'},
          {value:'Latvia',label:'拉脱维亚'},
          {value:'Lebanon',label:'黎巴嫩'},
          {value:'Lesotho',label:'莱索托'},
          {value:'Liberia',label:'利比里亚'},
          {value:'Libya',label:'利比亚'},
          {value:'Liechtenstein',label:'列支敦士登'},
          {value:'Lithuania',label:'立陶宛'},
          {value:'Luxembourg',label:'卢森堡'},
          {value:'Madagascar',label:'马达加斯加'},
          {value:'Malawi',label:'马拉维'},
          {value:'Malaysia',label:'马来西亚'},
          {value:'Maldives',label:'马尔代夫'},
          {value:'Mali',label:'马里'},
          {value:'Malta',label:'马耳他'},
          {value:'Mariana Is',label:'马里亚那群岛'},
          {value:'Martinique',label:'马提尼克'},
          {value:'Mauritius',label:'毛里求斯'},
          {value:'Mexico',label:'墨西哥'},
          {value:'Moldova',label:'摩尔多瓦'},
          {value:'Monaco',label:'摩纳哥'},
          {value:'Mongolia',label:'蒙古'},
          {value:'Montserrat Is',label:'蒙特塞拉特岛'},
          {value:'Morocco',label:'摩洛哥'},
          {value:'Mozambique',label:'莫桑比克'},
          {value:'Namibia',label:'纳米比亚'},
          {value:'Nauru',label:'瑙鲁'},
          {value:'Nepal',label:'尼泊尔'},
          {value:'Netheriands Antilles',label:'荷属安的列斯'},
          {value:'Netherlands',label:'荷兰'},
          {value:'New Zealand',label:'新西兰'},
          {value:'Nicaragua',label:'尼加拉瓜'},
          {value:'Niger',label:'尼日尔'},
          {value:'Nigeria',label:'尼日利亚'},
          {value:'North Korea',label:'朝鲜'},
          {value:'Norway',label:'挪威'},
          {value:'Oman',label:'阿曼'},
          {value:'Pakistan',label:'巴基斯坦'},
          {value:'Panama',label:'巴拿马'},
          {value:'Papua New Cuinea',label:'巴布亚新几内亚'},
          {value:'Paraguay',label:'巴拉圭'},
          {value:'Peru',label:'秘鲁'},
          {value:'Philippines',label:'菲律宾'},
          {value:'Poland',label:'波兰'},
          {value:'Portugal',label:'葡萄牙'},
          {value:'Puerto Rico',label:'波多黎各'},
          {value:'Qatar',label:'卡塔尔'},
          {value:'Reunion',label:'留尼旺'},
          {value:'Romania',label:'罗马尼亚'},
          {value:'Russia',label:'俄罗斯'},
          {value:'Saint Lueia',label:'圣卢西亚'},
          {value:'Saint Vincent',label:'圣文森特岛'},
          {value:'Samoa Eastern',label:'东萨摩亚(美)'},
          {value:'Samoa Western',label:'西萨摩亚'},
          {value:'San Marino',label:'圣马力诺'},
          {value:'Sao Tome and Principe',label:'圣多美和普林西比'},
          {value:'Saudi Arabia',label:'沙特阿拉伯'},
          {value:'Senegal',label:'塞内加尔'},
          {value:'Seychelles',label:'塞舌尔'},
          {value:'Sierra Leone',label:'塞拉利昂'},
          {value:'Singapore',label:'新加坡'},
          {value:'Slovakia',label:'斯洛伐克'},
          {value:'Slovenia',label:'斯洛文尼亚'},
          {value:'Solomon Is',label:'所罗门群岛'},
          {value:'Somali',label:'索马里'},
          {value:'South Africa',label:'南非'},
          {value:'Spain',label:'西班牙'},
          {value:'SriLanka',label:'斯里兰卡'},
          {value:'St.Lucia',label:'圣卢西亚'},
          {value:'St.Vincent',label:'圣文森特'},
          {value:'Sudan',label:'苏丹'},
          {value:'Suriname',label:'苏里南'},
          {value:'Swaziland',label:'斯威士兰'},
          {value:'Sweden',label:'瑞典'},
          {value:'Switzerland',label:'瑞士'},
          {value:'Syria',label:'叙利亚'},
          {value:'Tajikstan',label:'塔吉克斯坦'},
          {value:'Tanzania',label:'坦桑尼亚'},
          {value:'Thailand',label:'泰国'},
          {value:'Togo',label:'多哥'},
          {value:'Tonga',label:'汤加'},
          {value:'Trinidad and Tobago',label:'特立尼达和多巴哥'},
          {value:'Tunisia',label:'突尼斯'},
          {value:'Turkey',label:'土耳其'},
          {value:'Turkmenistan',label:'土库曼斯坦'},
          {value:'Uganda',label:'乌干达'},
          {value:'Ukraine',label:'乌克兰'},
          {value:'United Arab Emirates',label:'阿拉伯联合酋长国'},
          {value:'United Kiongdom',label:'英国'},
          {value:'United States of America',label:'美国'},
          {value:'Uruguay',label:'乌拉圭'},
          {value:'Uzbekistan',label:'乌兹别克斯坦'},
          {value:'Venezuela',label:'委内瑞拉'},
          {value:'Vietnam',label:'越南'},
          {value:'Yemen',label:'也门'},
          {value:'Yugoslavia',label:'南斯拉夫'},
          {value:'Zimbabwe',label:'津巴布韦'},
          {value:'Zaire',label:'扎伊尔'},
          {value:'Zambia',label:'赞比亚'}
        ],
        showPicker_date: false,
        showPicker_country:false,
        showPicker_job:false,
        showPicker_degree:false,
        showPicker_expiration:false,
        currentDate: new Date(1980, 0, 1),
        minDate: new Date(1900, 0, 1),
        minDate2: new Date(2025, 0, 1),
        maxDate: new Date(2099, 0, 1),
        options_job:['党政机关工作人员',
        '企事业单位职工','农民',
        '个体工商户','注册会计师',
        '律师','学生','金融机构从业人员','金融机构高级管理人员','无业','其他'],
        options_degree:['博士','硕士','大本','大专','中专','高中','初中及以下'],
        
        screenHeightNoChange:false,
      
      };
    },
    methods: {
      // 是否需要弹出投资者基本信息填写表及用户的基础数据接口：
      async investor_basic_info(){
          let res = await circleApi.investor_basic_info({
          });
          console.log('investor_basic_info',res)
          if (res.code == 1) {
            let data = res.data;
            if(data.is_popup_basic_info == 'yes'){
              this.ruleForm = {
                name: data.real_name,//姓名
                sex: data.sex,//性别
                birth:data.birthday,//出生日期
                country:'中国',//国籍
                job:'',//职业
                workplace:'',//工作单位
                office:'',//职务
                degree:'',//学历

                integrity:'',//诚信记录
                other:'',
                card:data.id_card,//身份证件  接口返回，不支持修改
                expiration:null,//身份证件有效期限
                phone: data.phone,//手机号  支持修改
                
                address : '',//联系地址
                
              }
            }
            else{
              this.backPage();
            }
          } else {
            //this.$message.error(res.message);
          }
      },
      onConfirm_date(time) {
        let date = new Date(time),
        month = date.getMonth()+1,
        day = date.getDate();
        date = `${date.getFullYear()}-${month > 10 ? month : `0${month}`}-${day > 10 ? day : `0${day}`}`
        this.ruleForm.birth = date;
        this.showPicker_date = false;
      },
      onConfirm_country(value) {
        this.ruleForm.country = value;
        this.showPicker_country = false;
      },
      onConfirm_job(value) {
        this.ruleForm.job = value;
        this.showPicker_job = false;
      },
      onConfirm_degree(value) {
        this.ruleForm.degree = value;
        this.showPicker_degree = false;
      },
      onConfirm_expiration(time) {
        let date = new Date(time),
        month = date.getMonth()+1,
        day = date.getDate();
        date = `${date.getFullYear()}-${month > 10 ? month : `0${month}`}-${day > 10 ? day : `0${day}`}`
        this.ruleForm.expiration = date;
        this.showPicker_expiration = false;
      },
      scrollFn(kind){
        this.screenHeightNoChange = kind;
        setTimeout(() => {
          document.documentElement.scrollTop  = 9999;
        }, 10);
        
      },
      // 提交表单且验证不通过后触发
      onFailed(error) {
        // error 可以打印看看，错误信息集合
        console.log(error)
        if (error.errors[0]) { // 
          Toast.fail(error.errors[0].message);
        }
      },
      onSubmit() {
          // 全局表单验证
          this.$refs['ruleForm'].validate().then(() => {
              if(this.ruleForm.integrity == 1 && this.integrity_record.length == 0){
                Toast.fail('请注明诚信记录');
              }
              else if(!this.agree){
                Toast.fail('请同意下方文字');
              }
              else{
                this.Apply();
              }
          }).catch(() => {
              Toast.fail('提交失败，请检查后再次提交')
          })
      },
      async Apply(){
        //申请接口
        let params = {
          real_name	:this.ruleForm.name,			//姓名
          sex				:this.ruleForm.sex,		//性别
          birthday	:this.ruleForm.birth,			//出生日期，格式：0000-00-00
          nationality:this.ruleForm.country,				//目前只支持提交中国
          work				:this.ruleForm.job,	//职业
          workplace		:this.ruleForm.workplace,		//工作单位
          position		:this.ruleForm.office,		//职务
          education		:this.ruleForm.degree,		//学历
          integrity		:this.ruleForm.integrity,		//是否有诚信记录 0-没有、1-有
          id_card	:this.ruleForm.card,				//身份证
          id_card_expire_time	:this.ruleForm.expiration ? this.ruleForm.expiration : '',	//身份证有效期，格式：0000-00-00
          address	:this.ruleForm.address,				//联系地址
          phone:this.ruleForm.phone,	//手机号		
        };
        if(this.ruleForm.integrity == 1 && this.integrity_record.length > 0){
          params.integrity_record = this.integrity_record.join(',');		//具体的诚信记录，如果诚信记录选无，此选项不用传值，多个用英文逗号隔开
        }
        if(this.ruleForm.integrity == 1 && this.ruleForm.other){
          params.integrity_record_other = this.ruleForm.other;	//手动输入的其他诚信记录，如果诚信记录选无，此选项不用传值
        }
        console.log(this.integrity_record.join(','),'this.integrity_record','params',params);
        //return;
        let res = await circleApi.add_investor_basic_info(params);          
          if(res.code == 1) {
            Toast.success('提交成功');
            setTimeout(() => {
              this.backPage()
            }, 100);
          
          } else {
            Toast.fail(res.message);
          }
      },
      // 返回页面
      backPage() {
        window.location.href = 'https://m.aigupiao.com/user/pagedo.html';
      },
    },
    computed:{

    },
    created(){

      this.columns_country = this.options_country.map(item => item.label);
      this.investor_basic_info();
      
    },
    mounted(){


    },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/sass/globalapp.scss";
    .application{
      background: #fff;
        min-height: 100vh;
    }

    .appl{
        margin: 0 auto 0;
        flex-shrink: 0;
        border-radius: 6px;
        border: 1px solid #DDD;
        &.appl2{
          padding-bottom: 25vh;
        }

        .header{
          color: #636363;
          font-size: 13px;
          line-height: 150%; 
          padding: 12px;
          padding-left: 102px;
          background: url(https://cdncos.aigupiao.com/assets/pc/img/2023/information_111.svg);
          background-size: 80px 60px;
          background-repeat: no-repeat;
          background-position: 12px;
        }


        .form_box2410{

          .border{
            background: #F5F6F7;
            height: 10px;
          }
          .boxbox{
            width: 100%;
            p{
              color: #939393;
              font-size: 13px;
              line-height: normal;
              margin-bottom: 10px;
              margin-top: 6px;
            }
            >h1{
              color: #646566;
            }
            a{
              color: #323233;
              
            }
            .alink{
                color:#ee0a24;
              }
          }


            //padding: 50px 280px;
            background: #fff;



          .sb_p{
                margin: 10px 0;
                display: flex;
                //align-items: center;
                
                color: #636363;
                font-size: 14px;
                line-height: 20px;;
                >svg{
                  margin-right: 8px;
                  width: 22px;
                  height: 22px;
                  margin-left: 12px;
                  flex-shrink: 0;
                }
              }

          .btn{
            margin: 10px 12px;
            
          }
        }
    }

</style>

<style lang="scss">
@import "~@/assets/sass/globalapp.scss";
.form_box2410{
  .integrity_box{
    padding-bottom: 10px;
    .van-cell{
      padding-bottom: 0;
    }
    .van-cell::after{
      display: none;
    }
    .van-field__body{
      >input{
        background: #FAFAFA;
        padding: 5px 0 5px 10px;
      }
      
    }
  }

  .van-radio__icon .van-icon{
    background-color: unset;
    border-color:unset;
    background: url(https://cdncos.aigupiao.com/assets/pc/img/2023/select_w.png);
    background-size:cover;
    border: unset;
  }

  .van-radio__icon--checked .van-icon{
    background: #FF443D;
    border-color:#FF443D;

    background-color: unset;
    border-color:unset;
    background: url(https://cdncos.aigupiao.com/assets/pc/img/2023/select_red.png);
    background-size:cover;
  }

  .van-icon-success:before{
    content: '';
  }

  .van-checkbox__icon{
    .van-icon-success:before{
      content: '\e728';
    }
  }
  .van-checkbox{
    margin-bottom: 10px;
  }

  .van-button--square{
    border-radius: 4px;
  }
  
  .van-field__label{
    margin-right: 5px;
  }
  .van-cell__title.van-field__label.other{
    >span{
      display: flex;
      width: 60px;
      line-height: 18px;
    }
    
  }
  .van-cell__title.van-field__label.other2{
    >span{
      display: none;
    }
    
  }
  .radio_box{
    .van-field__value{
      display: flex;
    }
  }

}

</style>
